import styled from 'styled-components';

const Wrapper = styled.article`
  .product-link {
    display: block;
    text-decoration: none;
    color: inherit;
    cursor: pointer;
  }

  .container {
    position: relative;
    background: #f9fafb;
    border-radius: 0.75rem;
    overflow: hidden;
    padding-bottom: 125%; /* aspect-ratio: 4/5 fallback */
    height: 0;
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    transition: transform 0.5s ease;
  }

  .product-link:hover img {
    transform: scale(1.05);
  }

  /* Product badges */
  .badges {
    position: absolute;
    top: 0.75rem;
    left: 0.75rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    z-index: 10;
  }

  .badge {
    padding: 0.25rem 0.625rem;
    border-radius: 9999px;
    font-size: 0.75rem;
    font-weight: 500;
  }

  .badge-new {
    background: #111718;
    color: #ffffff;
  }

  .badge-sale {
    background: #ef4444;
    color: #ffffff;
  }

  /* Wishlist button */
  .wishlist-btn {
    position: absolute;
    top: 0.75rem;
    right: 0.75rem;
    width: 2rem;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border: none;
    border-radius: 50%;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: all 0.2s;
    z-index: 10;

    svg {
      font-size: 1rem;
      color: #6b7280;
      transition: color 0.2s;
    }
  }

  .wishlist-btn:hover {
    background: #fef2f2;
    
    svg {
      color: #ef4444;
    }
  }

  footer {
    padding: 1rem 0.25rem;
    text-align: left;
  }

  footer h5 {
    font-family: 'Playfair Display', serif;
    font-size: 1rem;
    font-weight: 600;
    color: #111718;
    margin: 0 0 0.25rem 0;
    line-height: 1.4;
  }

  footer p {
    font-size: 0.875rem;
    font-weight: 500;
    color: #6b7280;
    margin: 0;
    letter-spacing: 0;
  }

  .price-container {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .original-price {
    text-decoration: line-through;
    color: #9ca3af;
    font-size: 0.875rem;
  }

  .sale-price {
    color: #ef4444;
    font-weight: 600;
  }
`;

export default Wrapper;
